import { generatePlugin } from '../component';

//contractPlugin
export const contractPlugin = generatePlugin('contract');

//costPayAppPlugin
export const costPayAppPlugin = generatePlugin('costPayApp');

//expensePlugin

export const expensePlugin = generatePlugin('expense');
